export default "__VITE_ASSET__306a1e17__"